export default function DisplayField({label, value}) {
  return (
    <>
      <div className='col'>{label}</div>
      <div className='col fw-bold'>{value}</div>
    </>
    );
}